import { h, Component, Fragment } from "preact";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import CashoutService from "../../../../services/cashout";
import Observer from "../../utils/observer";
import TicketLogic from "../../utils/ticket-logic";
import {Cell, CustomTable, EmptyRecordsMessage, HCell, HRow, Pagination, Panel, PanelRow, Row} from "../../utils/table-utils";
import MoneyFormatter from "../../utils/money-formatter";
import {OUTCOMES_STATUS} from "../../utils/ticket-statuses";
import OddsFormatter from "../../utils/odds-formatter";

import {CashoutBetsTable} from "../cashout-enhanced";

import * as U from "../../desktop-templates/menu-user";
import User from "../../../../services/user";
import AwrabetCashoutPage from "../../../awrabet/desktop-components/user/menu-cashout";

export default class CashoutPage extends AwrabetCashoutPage {
    render() {
        return <div>
			<U.SubTabsContainer>
				{Object.entries(this.state.tabs.list).map(
					([key,item]) => <U.Tab selected={key === this.state.tabs.current} onClick={e => this.switchTabs(key)} >{item.label}</U.Tab>
				)}
			</U.SubTabsContainer>
            <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded">{this.state.tabs.list[this.state.tabs.current].description}</div>
            <CashoutBetsTable {...this.state.response} livefeed={this.state.livefeed} onIdClick={ticket => TicketLogic.printTicket(ticket)} />
        </div>;
    }
}
